import SocialinPDF from '../documents/Socialin.pdf'

import styles from './Features.module.css'

const features = [
  {
    icon: "🌟",
    title: "Digitalització de registres i seguiment",
    description: "Transforma els teus registres en format digitals i realitza els seguiments de manera més eficient.",
    image: "path/to/image1.jpg"
  },
  {
    icon: "📢",
    title: "Millora la comunicació amb els diferents professionals.",
    description: "Els diferents canals permeten augmentar la comunicació entre els diferents interessats.",
    image: "path/to/image2.jpg"
  },
  {
    icon: "📑",
    title: "Transcripció automàtica dels seguiments fets amb veu.",
    description: "Realitza els seguiments en format audio i transcriu-los de manera automàtica, integrant-se al moment en el sistema.",
    image: "path/to/image2.jpg"
  },
  {
    icon: "🗓️",
    title: "Planifica i controla el compliment dels seguiments.",
    description: "Realitza un control dels seguiments, ja sigui en unitats realitzades o en temps de dedicació.",
    image: "path/to/image2.jpg"
  },
  {
    icon: "📊",
    title: "Informes visuals i efectius",
    description: "Genera informes visuals que faciliten la presa de decisions.",
    image: "path/to/image2.jpg"
  },
  {
    icon: "⏱",
    title: "Reducció de temps administratiu",
    description: "Automatitza tasques administratives i estalvia temps per dedicar-te al que realment importa.",
    image: "path/to/image3.jpg"
  },
  {
    icon: "🌍",
    title: "Accés des de qualsevol lloc",
    description: "Accedeix a la plataforma des de qualsevol dispositiu. No treballem només a l'oficina.",
    image: "path/to/image4.jpg"
  },
  {
    icon: "🔒",
    title: "Seguretat i privacitat garantides",
    description: "Protegeix les teves dades amb les millors pràctiques de seguretat.",
    image: "path/to/image5.jpg"
  },
  {
    icon: "📧",
    title: "Enviament automàtic de resums via email",
    description: "Rep informes i resums tan de les planificacions com dels usuaris concrets de manera predefinida.",
    image: "path/to/image6.jpg"
  },
  {
    icon: "💡",
    title: "Actualitzacions automàtiques i millores contínues",
    description: "Gaudeix de noves funcionalitats i millores constants.",
    image: "path/to/image7.jpg"
  }
]

const Features = () => {

  return (
    <section className={styles.section}>
      <div className={styles.grid}>
        {features.map((feature, index) => (
          <div key={index} className={styles.item}>
            <div className={styles.icon}>{feature.icon}</div>
            <div className={styles.content}>
              <h3 className={styles.featureTitle}>{feature.title}</h3>
              <p className={styles.description}>{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className={styles.contact}>
        <p className={styles.contactText}>Per a més informació, contacta'ns a:</p>
        <a href="mailto:codelabosona@gmail.com" className={styles.emailLink}>
          codelabosona@gmail.com
        </a>
        <div className={styles.downloadSection}>
          <a href={SocialinPDF} className={styles.downloadLink} download>
            Socialin - Descarregar PDF
          </a>
        </div>
      </div>
    </section>
  );
};

export default Features;